import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Badge, Text } from '@mantine/core';
import { IconTemplate } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import type { TemplateRow } from '@/features/templates/api';

export const Route = createFileRoute('/_app/templates/')({ component: TemplatesListPage });

function TemplatesListPage() {
  const navigate = useNavigate();
  return (
    <ResourceListPage<TemplateRow>
      title="Template"
      type="templates"
      columns={[
        {
          accessorKey: 'name',
          header: 'Nome',
          Cell: ({ row }) => (
            <div>
              <Text fw={500}>{row.original.name}</Text>
              {row.original.subject && <Text size="xs" c="dimmed">{row.original.subject}</Text>}
            </div>
          ),
        },
        // `category` è una relazione (non attributo): sort/filtro server-side → 400.
        { accessorKey: 'category', header: 'Categoria', enableSorting: false, enableColumnFilter: false, Cell: ({ cell }) => <Badge variant="light">{cell.getValue<string>() ?? '—'}</Badge> },
        { accessorKey: 'language', header: 'Lingua' },
        {
          // L'attributo JSON:API reale è `active` (api.gen): `isActive` non è ordinabile/filtrabile.
          accessorKey: 'isActive',
          header: 'Stato',
          enableSorting: false,
          enableColumnFilter: false,
          Cell: ({ cell }) =>
            cell.getValue<boolean>()
              ? <Badge color="green">Attivo</Badge>
              : <Badge color="gray">Inattivo</Badge>,
        },
      ]}
      searchField="name"
      onRowClick={(t) => void navigate({ to: `/templates/${t.id}` })}
      emptyMessage="Nessun template"
      emptyDescription="I template per email e documenti generati dal sistema appariranno qui."
      emptyIcon={IconTemplate}
    />
  );
}
